import React from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  YAxis,
} from "recharts";
import classNames from "classnames";
import { Currency } from "@app/types/currencies";
import { CustomTooltip } from "../custom-tooltip/CustomTooltip";

type Props = {
  baseCurrency: Currency;
  converCurrency: Currency;
  series: { date: string; rate: number }[];
};

const Chart: React.FC<Props> = React.memo(
  ({ series, baseCurrency, converCurrency }) => {
    return (
      <div
        className={classNames(
          "text-extra-small -mr-3 pt-15",
          "md:text-regular",
        )}
      >
        <ResponsiveContainer height={315} width="100%">
          <LineChart
            width={500}
            height={300}
            data={series}
            margin={{ right: 20 }}
          >
            <CartesianGrid stroke="#ccc" strokeDasharray="3" vertical={false} />
            <YAxis
              dataKey="rate"
              orientation="right"
              axisLine={false}
              width={30}
              domain={["dataMin", "dataMax"]}
              tickSize={0}
              tickMargin={10}
              tickCount={4}
              tickFormatter={(tick) =>
                (Math.trunc(Number(tick) * 100) / 100).toString()
              }
              stroke="#ffffff"
              interval={"preserveStartEnd"}
            />
            <Tooltip
              allowEscapeViewBox={{ x: true, y: true }}
              position={{ x: 0, y: -100 }}
              content={({ payload }) => (
                <CustomTooltip
                  payload={payload?.[0]?.payload ?? series[series.length - 1]}
                  baseCurrency={baseCurrency}
                  convertCurrency={converCurrency}
                />
              )}
            />
            <Line
              type="monotone"
              dataKey="rate"
              stroke="#008171"
              strokeWidth={3}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  },
);

Chart.displayName = "Chart";

export default Chart;
